/**
 * Classes and functions used to support table opertations
 * 
 * @package Utils
 */

var RefreshAfterSave = false;
var RefreshGridsAfterSave = false;
var PendingOperationRequests = 0; // counter incremented on AJAX form submit
									// and decremented on response received
var OperationErrorCode = 0;

var CurrentNodeName = '';
var CurrentNodeOperation = '';
var NodeParms = new Array();
var OpParms = new Array();

function cDetails(FormName, TableName)
{
	// constructor
	this.Name = FormName;
	this.TableName = TableName;
	this.DEBUG_SAVE = false;
	RegisterNode(this);

	this.GetTable = function()
	{
		if (this.Table == null)
		{
			this.Table = $('#' + this.TableName);
		}
		return this.Table;
	};

	this.GetForm = function()
	{
		if (this.Form == null)
		{
			this.Form = document.getElementById(this.Name);
			if (this.Form == null)
			{
				alert('Error: Cannot load ' + this.Name + ': form not found');
				return null;
			}
			if (this.Form.getAttribute('ReadOnly') == '1')
			{
				this.ReadOnly = true;
			}
		}
		return this.Form;
	};

	this.GetErrorBox = function()
	{
		return this.ErrorBox;
	};

	this.OnLoad = function()
	{
		this.GetForm();	// Ensure form is available up front
		this.LoadImages();
	};

	this.DoSave = function()
	{
		var Form = this.GetForm();
		if (Form)
		{
			var ParmArray = GetInputsForSave(this, Form);
			if (ParmArray.length > 0)
			{
				if (this.DEBUG_SAVE)
				{
					console.info('{cDetails:DoSave}  AJAXFormSubmit ' + Form.action + ' ' + ParmArray.join('&'));
				}
				AJAXFormSubmit(this, ParmArray, Form.action);
			}
		}
	};

	this.DoUpdate = function()
	{
		var Form = this.GetForm();
		if (Form)
		{
			var ParmArray = GetInputsForUpdate(this, Form);
			if (this.DEBUG_SAVE)
			{
				console.info('{cDetails:DoUpdate}  AJAXFormSubmit ' + Form.action + ' ' + ParmArray.join('&'));
			}
			AJAXFormSubmit(this, ParmArray, Form.action);
		}
	};

	this.DoSubmit = function(URL)
	{
		var Form = this.GetForm();
		if (Form)
		{
			var ParmArray = GetInputsForSubmit(this, Form);
			if (this.DEBUG_SAVE)
			{
				console.info('{cDetails:DoSubmit}  AJAXFormSubmit ' + Form.action + ' ' + ParmArray.join('&'));
			}
		}
		AJAXFormSubmit(this, ParmArray, URL);
	};

	this.DoRefresh = function()
	{
		// TBA
	};

	this.DoReset = function()
	{
		var Form = this.GetForm();
		if (Form)
			ResetInputs(Form);
	};

	this.DeleteNode = function()
	{
		// TBA
	};

	this.LoadImages = function()
	{
		if (FunctionExists(ImageLoad))
		{
			var Form = this.GetForm();
			if (Form)
				ImageLoad(Form);
		}
	};
}

// In a vertical view (details) nodes are forms
// In a list view (cList) nodes are rows of forms
// in FF10.0.2 creating a js super global without the var keyword makes it 'file
// local' in scope
var NodeList = new Array();
function RegisterNode(Node)
{
	var idx = NodeList.length;
	NodeList[idx] = Node;
}

function NodeCheck()
{
	for (var i = 0; i < NodeList.length;) {
		var El = document.getElementById(NodeList[i].Name);
		if (El === null) {
			RemoveNodeByIndex(i);
		} else {
			i++;
		}
	}
}

// remove a node from the NodeList array
function RemoveNode(NodeName)
{
	for ( var i = 0; i < NodeList.length; i++)
	{
		if (NodeList[i].Name === NodeName)
		{
			RemoveNodeByIndex(i);
			break;
		}
	}
}

function removeLastNode()
{
	RemoveNodeByIndex(NodeList.length-1);
}

function RemoveNodeByIndex(index)
{
	NodeList.splice(index, 1);
}


// Saves are asynchronous (each record is sent to a php file, which eventually
// replies)
// This logic will queue functions and execute them after all save operations
// have completed.
var OperationQueue = new function()
{
	Queue = [];
	TimerRunning = false;

	this.Add = function(FuncName, Parm)
	{
		var FuncArray = new Array();
		FuncArray[0] = FuncName;
		FuncArray[1] = Parm;
		Queue.push(FuncArray);
		return this;
	};

	this.Run = function()
	{
		PendingOperationRequests = 0;
		OperationErrorCode = 0;
		if (Queue[0])
		{
			var FuncArray = Queue[0];
			var FuncName = FuncArray[0];
			var FuncParm = FuncArray[1];

			eval(FuncName)(FuncParm);

			this.StartTimer();
		}
		else
		{
			if (isPALMode())
			{
				// trigger 'OperationQueueComplete' event, PALMode only, not used by Spectrum+
				$(document).trigger("OperationQueueComplete");
			}
			// allow a single AJAX alert for the next run of the queue
			ClearAjaxAlertFlag();
		}
	};

	this.StartTimer = function()
	{
		if ((TimerRunning == false) && (Queue.length > 0))
		{
			TimerFunc = 'OperationQueue.Timer()';
			setTimeout(TimerFunc, 100);
			TimerRunning = true;
		}
	};

	this.Timer = function()
	{
		// Wait for all pending responses, then report status
		TimerRunning = false;
		if (PendingOperationRequests > 0)
		{
			this.StartTimer();
			return;
		}

		if (OperationErrorCode != 0)
		{
			if (OperationErrorCode == '-7042')
			{
				DisplayRfc();
			}
			else if (OperationErrorCode == '-7029')
			{
				DisplayESig();
			}
			else
			{
				this.Clear();
				if (isPALMode())
				{   //  need to make sure OperationQueueComplete is called
					// this will fix the issue when new specimen creation process has started
					// and  some validation errors occured on the tabs
					// so new specimen creation process need to be completed
					$(document).trigger("OperationQueueComplete");
					jsPAL.closeNotification();
				}
			}
			return;
		}

		Queue.shift(); // task has successfully completed

		this.Run();
	};

	this.Clear = function()
	{
		Queue = [];
	};
};

function SetRefreshAfterSave(Flag)
{
	RefreshAfterSave = Flag;
}

function SetRefreshGridsAfterSave(Flag)
{
	RefreshGridsAfterSave = Flag;
}

function InitializeNodes()
{
	for ( var i = 0; i < NodeList.length; i++)
	{
		if (NodeList[i])
		{
			if (typeof NodeList[i].OnLoad === 'function')
			{
				NodeList[i].OnLoad();
			}
		}
	}
}

// Set which node to do the next set of operations
// Prepare for any/all operertions
// ReuseOpParms is optional boolean indicating that the OpParms from the previous operation should be reused
function SetupNodes(Operation, NodeName, ReuseOpParms)
{
	if (typeof ReuseOpParms === 'undefined' || false == ReuseOpParms)
		OpParms = new Array();

	if (Operation == 'Save')
	{
		DoForceSave = false;
	}
	else if (Operation == 'Add')
	{
		// Adding is mostly the same as a save, except we need to force the
		// saving (don't depend on modified fields)
		Operation = 'Save';
		DoForceSave = true;
	}

	CurrentNodeName = NodeName;
	CurrentNodeOperation = Operation;
}

function FindNode(NodeName)
{
	for ( var i = 0; i < NodeList.length; i++)
	{
		if (NodeList[i].Name == NodeName)
		{
			return NodeList[i];
		}
	}
	return null;
}

// Save the records for all the nodes
function SaveAll()
{
	SetupNodes('Save', 'All');
	OperationQueue.Add('SaveNodes');
	OperationQueue.Add('UpdateNodes');
	if (RefreshAfterSave)
	{
		OperationQueue.Add('RefreshNodes');
	}
	if (RefreshGridsAfterSave)
	{
		OperationQueue.Add('RefreshGrids');
	}
	OperationQueue.Run();
}

function SaveNodes()
{
	if (CurrentNodeName == 'All')
	{
		for (var i = 0; i < NodeList.length; i++)
		{
			var Node = NodeList[i];
			Node.DoSave();
		}
	}
	else
	{
		var Node = FindNode(CurrentNodeName);
		Node.DoSave();
	}
}

// Some fields in records are updated based on changes other records
// eg. DataGroup changes traverse down through the hierarchy
// eg. If a slide has multiple images, a change in one row must affect the other
// rows
// Therefore saving is a 2 pass operation: saving all modified records, then
// updating all records
function UpdateNodes()
{
	if (CurrentNodeName == 'All')
	{
		for ( var i = 0; i < NodeList.length; i++)
		{
			var Node = NodeList[i];
			Node.DoUpdate();
		}
	}
	else
	{
		var Node = FindNode(CurrentNodeName);
		Node.DoUpdate();
	}
}

function RefreshNodes()
{
	if (CurrentNodeName == 'All')
	{
		window.location.reload();
	}
	else
	{
		// Refresh just the node
		var Node = FindNode(CurrentNodeName);
		Node.DoRefresh();
	}
}

function RefreshGrids()
{
	$(".ui-jqgrid-btable").trigger("reloadGrid");
	$('.ui-tabs-nav a').removeClass('Modified');	// FieldModified
	$('[aria-selected="true"] a').removeClass('Modified')	// FieldModified
}

function SubmitAllNodes(URL)
{
	SetupNodes(URL, 'All');
	OperationQueue.Add('SubmitNodes');
	if (RefreshAfterSave)
	{
		OperationQueue.Add('RefreshNodes');
	}
	if (RefreshGridsAfterSave)
	{
		OperationQueue.Add('RefreshGrids');
	}
	OperationQueue.Run();
}

function SubmitNode(NodeName, URL)
{
	SetupNodes(URL, NodeName);
	OperationQueue.Add('SubmitNodes');
	OperationQueue.Run();
}

function SubmitNodes()
{
	// var URL = CurrentNodeOperation;
	if (CurrentNodeName == 'All')
	{
		for ( var i = 0; i < NodeList.length; i++)
		{
			var Node = NodeList[i];
			if (Node)
			{
				Node.DoSubmit(CurrentNodeOperation);
			}
		}
	}
	else
	{
		var Node = FindNode(CurrentNodeName);
		if (Node)
		{
			Node.DoSubmit(CurrentNodeOperation);
		}
	}
}

function ResetAll()
{
	for ( var i = 0; i < NodeList.length; i++)
	{
		var Node = NodeList[i];
		Node.DoReset();
	}
	$('.ui-tabs-nav a').removeClass('Modified');	// FieldModified
	$('[aria-selected="true"] a').removeClass('Modified');	// FieldModified
	$(':input').removeClass('Invalid');

	HideEsig();
}

function SaveNode(NodeName)
{
	SetupNodes('Save', NodeName);
	OperationQueue.Add('SaveNodes');
	OperationQueue.Run();
}

function EventButton(NodeName, EventName)
{
	SetupNodes('Save', NodeName);

	// Add event
	OpParms[OpParms.length] = 'Event=' + encodeURIComponent(EventName);

	OperationQueue.Add('SaveNodes');
	OperationQueue.Add('UpdateNodes');
	OperationQueue.Run();
}

function AJAXFormSubmit(Node, ParmArray, URL)
{
	var Parms = ParmArray.join('&');

	var Receiver = new function()
	{
		this.Node = Node;

		this.Receive = function(http_request)
		{
			if ((http_request.readyState == 4) && (http_request.status == 200))
			{
				PendingOperationRequests--;

				try
				{
					var incoming = ParseAjaxResponse(http_request.response);
					this.ProcessSaveResponse(incoming);
					archiveGeneral.processDoNotArchive();
					PageRedirect(this.Node, incoming);
				}
				catch (e)
				{
					DisplayJsonError(e, http_request);
				}
			}
		};

		this.ProcessSaveResponse = function(Incoming)
		{
            if (Incoming != null && !Incoming.Alert)
            {
                var Table = this.Node.GetTable();
                if (Table)
                {
                    var CellMap = {};
                    Table.children().each(function()
                    {
                        var $Row = $(this);
                        $Row.children().each(function()
                        {
                            // Get the first TD from the table (TH is usually child[0])
                            var Cell = $(this).get(0);
                            if (Cell.tagName == 'TD')
                            {
                                var ColumnName = Cell.getAttribute('ColumnName');
                                if (ColumnName)
                                {
                                    CellMap[ColumnName] = Cell;
                                }
                            }
                        });
                    });

                    for (var ColumnName in Incoming.Cells)
                    {
                        if (CellMap[ColumnName])
                        {
                            var Cell = CellMap[ColumnName];

                            var NewData = Incoming.Cells[ColumnName];
                            if (NewData.Error == undefined)
                            {
                                var Type = '';
                                var Child = CellMap[ColumnName].children[0];
                                if (Child != undefined)
                                {
                                    // Javascript will not let you overwrite a file's value (its name)
                                    Type = Child.type;
                                }
                                if (Type != "file")
                                {
                                    CellMap[ColumnName].innerHTML = NewData.Contents;
                                }
                            }

                            var $Label = $('#' + NewData.TableName + '_' + ColumnName + '_Label');
                            if ($Label.length > 0)
                            {
                                if (NewData.Error)
                                {
                                    OperationErrorCode = 1;
                                    // Label.innerHTML = NewData.Error;

                                    var ErrorDetails = {};
                                    ErrorDetails['data'] = NewData.TableName + ' ' + Cell.getAttribute('prompt') + ' ' + NewData.Error;
                                    ErrorDetails['elem'] = CellMap[ColumnName];
                                    $('body').trigger('ProcessSaveResponseError', ErrorDetails);
                                }
                                else
                                {
                                    // Clear any previous errors
                                    var Label = $Label.get(0);
                                    Label.innerHTML = '';
                                }
                            }
                        }
                    }
                }
            }
			CheckOperationStatus(Node, Incoming);
		};
	};

	PendingOperationRequests++;
	HTTPRequest(URL, 'POST', Parms, Receiver);

	return false;
}

function CheckOperationStatus(Node, Incoming)
{
	// Protect against empty input:
    Incoming = Incoming || {};

	HideSpectrumMessageBox();

	if (Incoming.ErrorCode == null)
	{
		if ((Incoming.ErrorMsg == null) && (Incoming.Alert == null))
		{
			// Do not reset any error here, you could overwrite an error from
			// another node.
			// This should only be cleared before each operation.
			// OperationErrorCode = 0;

			// if the Node has an Operations Event defined, trigger it
			if (undefined !== Node.OperationsEvent)
			{
				var eventData = new Object();
				for (key in Node)
				{
					if (typeof (Node[key]) !== 'function')
					{
						eventData[key] = Node[key];
					}
				}
				if (undefined !== Incoming.Ids)
				{
					eventData.Ids = Incoming.Ids;
				}
				else if (undefined !== Node.Ids)
				{
					eventData.Ids = Node.Ids;
				}
				if (undefined !== Incoming.Status)
				{
					eventData.Status = Incoming.Status;
				}
				$(document).trigger(Node.OperationsEvent, eventData);
			}

			if (Incoming.Cells)
			{
				if (Incoming.Cells.length > 0)
				{
					if ('undefined' !== typeof jsPAL)
					{
						if ('function' === typeof (jsPAL.cmdBar.commandBarFinishedSavingEvent))
						{
							jsPAL.cmdBar.commandBarFinishedSavingEvent();
						}
					}
					if ('undefined' !== typeof jsPAL.completeCaseSaveAllEvent)
					{
						if ('function' === typeof (jsPAL.completeCaseSaveAllEvent))
						{
							jsPAL.completeCaseSaveAllEvent();
						}
					}
				}
			}

			$('body').trigger('ProcessSaveResponse', Incoming);

			return OperationErrorCode;
		}
		Incoming.ErrorCode = -1;
	}

	OperationErrorCode = Incoming.ErrorCode;

	if ((Incoming.ErrorCode == '-7029') || (Incoming.ErrorCode == '-7042'))
	{
		// Do not display an error
		return OperationErrorCode;
	}

	//
	// Display the error
	//

	if (Incoming.Alert)
	{
		DisplayOperationError(null, Incoming.Alert);
		if(Incoming.Alert === 'The password is incorrect')
		{
			EnableElements('#GenerateForm input,#GenerateForm select'); //Re-enable the form elements
		}
		return OperationErrorCode;
	}

	var ErrorBox = Node.GetErrorBox();
	if (ErrorBox == null)
	{
		ErrorBox = FindElementWithClass(document, 'GlobalErrorBox');
	}
	if (Incoming.ErrorMsg != null)
	{
		DisplayOperationError(ErrorBox, Incoming.ErrorMsg);
	}
	else if (Incoming.ErrorCode == '-7043')
	{
		DisplayOperationError(ErrorBox, 'Note: You cannot sign this because your Spectrum account user does not have a Full Name - contact your system administrator');
	}
	else if (Incoming.ErrorCode != -1)
	{
		// ErrorCode of -1 implies a field error
		DisplayOperationError(ErrorBox, 'Error Code: ' + Incoming.ErrorCode);
	}

	return OperationErrorCode;
}

function DisplayOperationError(Box, Msg)
{
	if (isPALMode())
	{
		jsPAL.closeNotification();
	}
	if (Box)
	{
		Box.style.display = '';
		Box.innerHTML += Msg + '<br>';
	}
	else
	{
		alert(Msg);
	}
}

function DeleteTheNodes()
{
	var ParmArray = GetInputsForSubmit(this, Form);

	if (CurrentNodeName == 'All')
	{
		for ( var i = 0; i < NodeList.length; i++)
		{
			var Node = NodeList[i];
			Node.DeleteTable(ParmArray);
		}
	}
	else
	{
		var Node = FindNode(CurrentNodeName);
		Node.DeleteTable(ParmArray);
	}
}

function DisplayESig()
{
	var ESigWindow = document.getElementById('esigDiv');
	if (ESigWindow == null)
	{
		return;
	}

	// Check for dialog box initialized
	if ($('#esigDiv').hasClass('ui-dialog-content'))
	{
		document.getElementById('SigUserName').value = '';
		document.getElementById('SigPassword').value = '';
		$('#esigDiv').dialog('open');
		return;
	}

	ESigWindow.className = 'esigDiv';
	ESigWindow.style.display = '';

	document.getElementById('SigUserName').value = '';
	document.getElementById('SigPassword').value = '';

	document.getElementById('SigUserName').focus();
}

function SubmitESig()
{
	var ESigUserName = document.getElementById('SigUserName').value;
	var ESigPassword = document.getElementById('SigPassword').value;

	OpParms[OpParms.length] = 'SigUserName=' + encodeURIComponent(ESigUserName) + '&SigPassword=' + encodeURIComponent(ESigPassword);

	// if (CurrentNodeOperation == 'Save')
	// DoForceSave = true;

	HideEsig();

	// only refresh the nodes in SP+
	if (false === isPALMode())
	{
		OperationQueue.Add('RefreshNodes');
	}

	// Reissue
	OperationQueue.Run();
}

function CancelESig()
{
	OperationQueue.Clear();
        if (isPALMode())
        {
            // PAL mode, all input buttons have been disabled, so reenable them
            $('input[type="button"]').removeAttr('disabled').removeClass('ui-state-disabled');
        }
	HideEsig();
}

function HideEsig()
{
	var esigWindow = document.getElementById('esigDiv');
	if (esigWindow)
	{
		esigWindow.style.display = 'none';
	}
	// Check for dialog box initialized
	if ($('#esigDiv').hasClass('ui-dialog-content'))
	{
		$('#esigDiv').dialog('close');
	}
}

function DisplayRfc()
{
	var RfcWindow = document.getElementById('RfcDiv');
	if (RfcWindow == null)
	{
		return;
	}

	// Clear the last comment
	if (isset(document.getElementById('RfcComment')))
	{
		document.getElementById('RfcComment').value = '';
	}

	// Check for dialog box initialized
	if ($('#RfcDiv').hasClass('ui-dialog-content'))
	{
		$('#RfcDiv').dialog('open');
		return;
	}

	// Display the window
	RfcWindow.style.display = '';
	if (isset(document.getElementById('RfcValue')))
	{
		document.getElementById('RfcValue').focus();
	}
}

function SubmitRfc()
{
	var RfcValue = document.getElementById('RfcValue').value;
	var RfcComment = document.getElementById('RfcComment').value;

	OpParms[OpParms.length] = 'RfcValue=' + RfcValue + '&RfcComment=' + RfcComment;

	// if (CurrentNodeOperation == 'Save')
	// DoForceSave = true;

	HideRfc();

	// Try again
	OperationQueue.Run();
}

function CancelRfc()
{
	HideRfc();
	OperationQueue.Clear();
	if (isPALMode())
	{
            // PAL mode, all input buttons have been disabled, so reenable them
            $('input[type="button"]').removeAttr('disabled').removeClass('ui-state-disabled');
            jsPAL.closeNotification();
	}
}

function HideRfc()
{
	var RfcWindow = document.getElementById('RfcDiv');
	RfcWindow.style.display = 'none';
	// Check for dialog box initialized
	if ($('#RfcDiv').hasClass('ui-dialog-content'))
	{
		$('#RfcDiv').dialog('close');
	}
}

function PageRedirect(Node, Incoming)
{
	// only redirect to a new page if all operations have completed error free.
	if ((PendingOperationRequests == 0) && (OperationErrorCode == 0))
	{
		if (Incoming.GoToPage)
		{
			document.location.href = Incoming.GoToPage;
			// Node.LoadImages();
		}
		else if (Incoming.SubmitForm)
		{
			var Form = Node.GetForm();
			if (Form)
			{
				AddParmsToForm(Form, Incoming.SubmitForm);
				Form.submit();
			}
		}
		else if (Incoming.Refresh)
		{
			window.location.reload();
		}
	}
}

function GetInputsForSave(Node, Element)
{
	var ParmArray = new Array();
	GetInputParms(Element, ParmArray, 'Modified');	// FieldModified
	if (ParmArray.length > 0)
	{
		ParmArray[ParmArray.length] = 'DoSave=1&Pass=1';
		GetBaseParameters(Node, Element, ParmArray);
		GetInputParms(Element, ParmArray, 'Required');
		if (Element.nodeName != "FORM")
		{
			// For Foreign Keys in DataViews Use ForeignKeyTableName on the element			
			var ForeignKeyTableName = Element.getAttribute('ForeignKeyTableName');
			var SqlTableName = Element.getAttribute('TableName');
			var TN = (ForeignKeyTableName ? ForeignKeyTableName : SqlTableName);
			if (TN)
			{
				if (('Image' === TN) && ('Slide' === Node.TableName))
				{
					//  -- Slide is an Image issue --
					//In the details list for the SSP fields
					//The cTable.php function CreateImageFields() hard coded the table names to be image
					//  HOWEVER, cRecord.PHP has all of the ssp slides in the SESSION table called Slide so set the tablename to slide					
					TN = 'Slide';
				}
				ParmArray[ParmArray.length] = 'TableName=' + TN;
			}
		}
	}
	return ParmArray;
}

function GetInputsForUpdate(Node, Element)
{
	var ParmArray = new Array();
	ParmArray[0] = 'UpdateOnly=1&Pass=2';
	GetBaseParameters(Node, Element, ParmArray);
	GetInputParms(Element, ParmArray, 'Modified');	// FieldModified
	GetInputParms(Element, ParmArray, 'Required');
	if (Element.nodeName != "FORM")
	{
		// For Foreign Keys in DataViews Use ForeignKeyTableName on the element
		var ForeignKeyTableName = Element.getAttribute('ForeignKeyTableName');
		var SqlTableName = Element.getAttribute('TableName');
		var TN = (ForeignKeyTableName ? ForeignKeyTableName : SqlTableName);
		if (TN)
		{
			ParmArray[ParmArray.length] = 'TableName=' + TN;
		}
	}
	return ParmArray;
}

function GetInputsForSubmit(Node, Element)
{
	var ParmArray = new Array();
	GetBaseParameters(Node, Element, ParmArray);
	GetInputParms(Element, ParmArray, '');
	return ParmArray;
}

function GetBaseParameters(Node, Element, ParmArray)
{
	ParmArray[ParmArray.length] = 'NodeName=' + Node.Name;
	if (Node.ReadOnly)
	{
		ParmArray[ParmArray.length] = 'ReadOnly=1';
	}
	for (var i = 0; i < OpParms.length; i++)
	{
		ParmArray[ParmArray.length] = OpParms[i];
	}
}

(function configureHandleLogoff () {
  var global = namespace.using('leica.pi.global');
  global.events.on('before-logoff', function () {
    window.OverrideSaveCheck = true;
  });
}());

function CheckDataUnsaved()
{
	if (!OverrideSaveCheck)
	{
		var ParmArray = new Array();
		GetInputParms(document, ParmArray, 'Modified');	// FieldModified
		if (ParmArray.length > 0)
		{
			return true;
		}
	}

	OverrideSaveCheck = false;
	return false;
}

function GetInputParms(Element, ParmArray, NeededClass)
{
	if (undefined === Element)
	{
		return;
	}
	var Inputs = GetInputs(Element);
	if (undefined === Inputs)
	{
		return;
	}

	for ( var i = 0; i < Inputs.length; i++)
	{
		var Input = Inputs[i];
		if ((NeededClass != '') && (hasClass(Input, NeededClass) == false))
		{
			continue;
		}

		var inputSqlColumnName = Input.name || Input.id;

		if (Input.type == 'checkbox')
		{
			if (Input.checked == true)
			{
				ParmArray[ParmArray.length] = inputSqlColumnName + '=1';
			}
			else
			{
				ParmArray[ParmArray.length] = inputSqlColumnName + '=0';
			}

		}
		else if (Input.type == 'radio')
		{
			if (Input.checked == true)
			{
				ParmArray[ParmArray.length] = inputSqlColumnName + '=' + encodeURIComponent(Input.value);
				// else
				// Only pass the checked button - or else the last button
				// would win (PHP will only accept one parameter)
			}
		}
		else if (Input.type != 'button')
		{
			ParmArray[ParmArray.length] = inputSqlColumnName + '=' + encodeURIComponent(Input.value);
		}
	}
}

